<template>
  <div class="btn-group btn-group-sm">
    <button v-if="can_access('deal_approve','view') && row.sub_count==1" class="btn" :class="row.deleted_at?'btn-cancelled':(row.approved_by?'btn-completed':'btn-pending')" :title="row.deleted_at?'Cancelled Deal':'Approve Deal'" @click="row.deleted_at?'':showModal('approve')"><i :class="row.deleted_at?'fa fa-times-circle':'fa fa-check-circle'"></i>{{row.deleted_at?'Cancelled':(row.approved_by?'Approved':can_access('deal_approve','modify')?'Approve':'Waiting For Approve')}}</button>

    <b-modal ref="edit-deal-out" :title="(action=='approve'?'Approve':'Add')+' Deal'" size="xl" hide-footer v-if="can_access('deal_approve','view')">
      <DealInvoice :row="rowData" @tradeFormReRender="tradeFormReRender" v-if="action=='approve'"/>
    </b-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import AddDealForm from '@/components/Accounts/AddDealForm';
import DealInvoice from '@/components/Accounts/DealInvoice';
import common from '@/assets/js/common.js';
export default {
  props: ['row', 'nested','refresh'],
  mixins: [common],
  data(){
    return {
      show: 1,
      rowData:{},
      action:''
    }
  },
  components: { AddDealForm,DealInvoice },
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
  },
  computed: {
    isDisplayRowVisible () {
      if (this.nested.comp !== 'SubTrades') return
      return this.nested.visible
    },
  },
  methods: {
    tradeFormReRender(response) {
      if(response.code==0){
        this.$refs['edit-deal-out'].hide();
        this.show = 1;
        this.refresh();
        this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    },
    showModal(action) {
      if(this.row.sub_count <= 1 || action == 'sub_deal'){
        this.action = action;
        if(action=='edit'){
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'edit'
            //this.rowData.account_number = '';
            //this.rowData.client_name = '';
        }
        else if(action=='approve'){
          this.rowData = this.duplicate(this.row);
          this.rowData.action = 'approve'
        }
        else if(action=='delete'){
          if(confirm("Do you really want to delete?")){
            this.show = false;
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'delete';
            this.rowData.status = 0;
          }else return;
        }
        else if(action=='sub_deal'){
          this.rowData = this.duplicate(this.row);
          this.rowData.action = 'sub_deal'
          this.rowData.id = '';
          this.rowData.contract_note = '';
        }
        else if(action=='copy'){
          this.rowData = this.duplicate(this.row);
          this.rowData.action = 'create'
          this.rowData.id = '';
          this.rowData.contract_note = '';
          this.rowData.ticket_number = '';
          //this.rowData.account_number = '';
          //this.rowData.client_name = '';
        }
        this.$refs['edit-deal-out'].show()
      }else{
        this.$toasted.info("You can not do this action in overall ticket",{duration:1500});
      }
    },
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
